'use client';

import ProductAndCategory from '@/joystagram-components/components/consumer/product-and-category';

export default function ProductAndCategoryClient({
  productOptionsPromise,
  productHeroImagePromise,
  productCylindoHeroImagePromise,
  productBasicDetailsPromise,
  category,
  slug,
  serverCategoryData,
}) {
  return (
    <ProductAndCategory
      productOptionsPromise={productOptionsPromise}
      productHeroImagePromise={productHeroImagePromise}
      productCylindoHeroImagePromise={productCylindoHeroImagePromise}
      productBasicDetailsPromise={productBasicDetailsPromise}
      category={category}
      slug={slug}
      serverCategoryData={serverCategoryData}
    />
  );
}
